type RouteLoader<T> = () => Promise<T>;

export const createRoutePreloader = <T,>(loader: RouteLoader<T>) => {
  let promise: Promise<T> | null = null;

  return () => {
    if (!promise) {
      promise = loader().catch((error) => {
        promise = null;
        throw error;
      });
    }

    return promise;
  };
};

export const preloadConversationsPage = createRoutePreloader(
  () => import('../pages/Conversations/Conversations')
);
